import { MCP_CLIENT_CONFIG_TEMPLATE } from '@common/modules/package-manager-instructions'

export const MCP_TECHNOLOGY_ID = 'mcp'

export const MCP_ENDPOINT_PATH = 'mcp'

export const MCP_DEFAULT_SERVER_NAME = 'graftcode-gateway'

export const MCP_CLIENT_CONFIG = MCP_CLIENT_CONFIG_TEMPLATE
